import { ConnectButton } from "@rainbow-me/rainbowkit";

function CreateCollective({ disabled, buttonClassName, onSetConnectingWallet }) {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <div className='text-center mt40'>
                    <button
                      className={buttonClassName}
                      disabled={disabled}
                      onClick={(event) => {
                        openConnectModal(event);
                        onSetConnectingWallet(true);
                      }}
                    >
                      + Contribute and Launch
                    </button>
                  </div>
                );
              }
              if (chain.unsupported) {
                return (
                  <div className='text-center mt40'>
                    <button
                      type="button"
                      disabled={disabled}
                      className={buttonClassName}
                      onClick={openChainModal}
                    >
                      + Contribute and Launch
                    </button>
                  </div>
                );
              }
              return (
                <div className='text-center mt40'>
                  <button
                    type="button"
                    disabled={disabled}
                    className={buttonClassName}
                    onClick={openAccountModal}
                  >
                    + Contribute and Launch
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}

export default CreateCollective;
